






















import { Component, Vue } from 'vue-property-decorator';

interface IItems {
  text: string;
  value: any;
  icon?: string;
  img?: string;
}

@Component({
  props: {
    data: { type: String || Array as () => string[], required: false },
    items: { type: Array as () => IItems[], required: true },
  },
})
export default class DropDownMenu extends Vue {
  protected data!: string|string[];
  protected items!: IItems[];

  private isOpen: boolean = false;
  private image: string|undefined = undefined;

  private created() {
    this.checkImage();

    const handleEscape = (e: {key: string}) => {
      if (e.key === 'Esc' || e.key === 'Escape') {
        this.isOpen = false;
      }
    };

    document.addEventListener('keydown', handleEscape);

    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('keydown', handleEscape);
    });
  }

  private checkImage() {
    if (this.data && typeof this.data === 'string') {
      const index = this.items.findIndex((item) => item.value === this.data);
      if (this.items[index].img) {
        this.image = this.items[index].img;
      }
    }
  }
}
